import CustomEntity from "../model2/custom-entity/custom-entity"
import ModalCustomEntity from "./custom-entities/modal-custom-entity"

export default class ModalsCustomEntity {

    createEntity(callback: callback) {
        gd.modal.showV4({
            className   : 'modal-custom-entity',
            component   : ModalCustomEntity,
            params      : {
                onSubmit    : async (model: CustomEntity)=>{
                    callback(model)
                },
            }
        })
    }

    editEntity(entity: CustomEntity, callback: callback) {
        gd.modal.showV4({
            className   : 'modal-custom-entity',
            component   : ModalCustomEntity,
            params      : {
                entity,
                onSubmit    : (model: CustomEntity)=>{
                    callback(model)
                },
            }
        });
    }
}
